import { Typography } from 'antd';
import React from 'react';
import { PAGE_ID } from '@/infrastructure/reporter/datong/id';
import { useReportPage } from '@/infrastructure/reporter/datong/report';
import { LiteLayout } from '@/presentation/layouts/lite';
import { RegisterForm } from '@/presentation/pages/register/form';
import styles from './index.module.scss';

const { Title } = Typography;

const RegisterPage = () => {
  useReportPage(PAGE_ID.register);

  return (
    <LiteLayout showAvatar={false}>
      <div className={styles.registerPage}>
        <Title level={4} className={styles.title}>完善账号信息</Title>
        <RegisterForm />
      </div>
    </LiteLayout>
  );
};

export default RegisterPage;
